export enum FavoriteIposBlock {
  Root = 'FavoriteIpos',
}
